import api from '@/lib/api';

/**
 * Shape fixed by the backend: GET /metrics/admin builds its own DTO by hand
 * instead of projecting a model, so there is no `fields` param to send.
 *
 * Always exactly 12 entries, oldest first. Months with no activity come back as
 * explicit zeros, not missing: the backend fills the skeleton, because a SQL
 * GROUP BY only returns months that have rows and the gaps would read as zeros
 * on the chart without being zeros.
 */
export interface AdminGrowthMonth {
  /** "2026-09" */
  month: string;
  tournaments: number;
  activeClubs: number;
  activePlayers: number;
  fee: number;
  /** True only for the month in progress, which is incomplete by definition. */
  partial: boolean;
}

export const adminMetricsApi = {
  growth: async (): Promise<AdminGrowthMonth[]> => {
    const response = await api.get('/metrics/admin');
    return response.data;
  },
};
